export const PLATFORMS = {
  epic:    { id: 'epic',    label: 'Epic Games', color: '#3B82F6', url: 'https://store.epicgames.com' },
  steam:   { id: 'steam',   label: 'Steam',       color: '#66c0f4', url: 'https://store.steampowered.com' },
  gog:     { id: 'gog',     label: 'GOG',          color: '#b45bd4', url: 'https://www.gog.com' },
  itchio:  { id: 'itchio',  label: 'Itch.io',      color: '#fa5c5c', url: 'https://itch.io' },
};

export const ALL_PLATFORMS = 'all';
